module.exports = __webpack_public_path__ + "img/dinkenclave_cover2.ea33198a.jpeg";